// PH-6c Transcript timeline helpers (uiux §7). Pure + L1-testable. These render
// whatever speaker labels the segments carry: today ASR returns a constant
// "Speaker" (no diarization), so it degrades to one timeline; when real
// diarization lands (DashScope paraformer, P2) the same helpers group turns per
// speaker and colour them. No fabricated speakers — grouping reflects the data.

export interface TranscriptSeg { speaker: string; startMs: number; text: string; }
export interface Turn { speaker: string; startMs: number; text: string; }

/** ms → mm:ss clock. */
export function fmtClock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

/** Distinct speakers in order of first appearance. */
export function speakerOrder(segments: readonly TranscriptSeg[]): string[] {
  const seen: string[] = [];
  for (const s of segments) if (!seen.includes(s.speaker)) seen.push(s.speaker);
  return seen;
}

// Fixed speaker hues (uiux §color): first speaker = brand (proxy for 本人),
// others cycle blue 200° / rose 335° / green 150° / amber 45° / violet 275°.
const SPEAKER_HUES = [200, 335, 150, 45, 275];

/** A CSS colour for a speaker, stable by its position in `order`. */
export function speakerColor(speaker: string, order: readonly string[]): string {
  const idx = order.indexOf(speaker);
  if (idx <= 0) return "var(--color-primary-600)";
  const hue = SPEAKER_HUES[(idx - 1) % SPEAKER_HUES.length];
  return `hsl(${hue}, 55%, 45%)`;
}

/** Merge consecutive same-speaker segments into turns (keeps the turn's start). */
export function groupTurns(segments: readonly TranscriptSeg[]): Turn[] {
  const turns: Turn[] = [];
  for (const s of segments) {
    const last = turns[turns.length - 1];
    if (last !== undefined && last.speaker === s.speaker) {
      last.text = `${last.text} ${s.text}`.trim();
    } else {
      turns.push({ speaker: s.speaker, startMs: s.startMs, text: s.text });
    }
  }
  return turns;
}
